<template>
  <img class="a-vdxb-brand-logo" src="@/images/corporatebrandmark.svg" alt="" />
  <img class="a-vdxb-brand-logo" src="@/images/COTOHA_VoiceDX_Basic.svg" alt="" />
</template>

<script>
import { mapModifiers } from '@/libs/component';
export default {
  name: 'a-vdxb-brand-logo',
  props: {
    variant: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(null|horizontal)/);
      },
    },
  },
};
</script>
